import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { PopUpRenderData } from '../../../networkPopUps/types';

export class BaseNetworkActionHelper {
  public async processAction(records: Array<ProtectedEntity>): Promise<PopUpRenderData> {
    return {
      isError: false,
    };
  }
}
